export default {
  USER_ROLE_ADMIN: 1,
  USER_ROLE_TEACHER: 2,
  USER_ROLE_STUDENT: 3,
  USER_ROLE_CONTACT: 4,
  USER_ROLE_SUBSCRIBER: 5,
  USER_ROLE_EC: 6,
  USER_ROLE_SM: 7,
};
